// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "scroll-sentinel{display:block}", "",{"version":3,"sources":["webpack://./src/shared/framework/components/behaviors/scroll-sentinel/scroll-sentinel.scss"],"names":[],"mappings":"AAEA,gBAEC,aAAA","sourcesContent":["@import \"resources/index\";\r\n\r\nscroll-sentinel\r\n{\r\n\tdisplay: block;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
